import React, { useState } from "react";

export default function ProviderIcon({
  provider = null,
  providerId = null,
  iconUrl = null,
  size = 22,
  className = "",
  style = {},
}) {
  const [imageError, setImageError] = useState(false);

  const resolvedId = (provider?.id || providerId || "").toLowerCase();
  const resolvedUrl = iconUrl || provider?.icon_url;

  // 1. If an icon_url is supplied from backend (SVG, PNG, Data URL) and didn't fail
  if (resolvedUrl && !imageError) {
    return (
      <img
        src={resolvedUrl}
        alt={provider?.name || resolvedId}
        className={`provider-icon-img ${className}`}
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "inline-block",
          verticalAlign: "middle",
          ...style,
        }}
        onError={() => setImageError(true)}
      />
    );
  }

  // 2. Built-in vector SVG fallbacks for core providers
  if (resolvedId === "jira") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`provider-svg-icon ${className}`}
        style={{ display: "inline-block", verticalAlign: "middle", ...style }}
      >
        <path
          d="M11.53 2C11.53 7.244 15.786 11.5 21.03 11.5H22V2H11.53Z"
          fill="#0052CC"
        />
        <path
          d="M5.765 7.765C5.765 13.009 10.021 17.265 15.265 17.265H16.235V7.765H5.765Z"
          fill="#2684FF"
        />
        <path
          d="M0 13.53C0 18.774 4.256 23.03 9.5 23.03H10.47V13.53H0Z"
          fill="#0052CC"
        />
      </svg>
    );
  }

  if (resolvedId === "servicenow") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`provider-svg-icon ${className}`}
        style={{ display: "inline-block", verticalAlign: "middle", ...style }}
      >
        <circle cx="12" cy="12" r="10" fill="#293E40" />
        <path
          d="M12 5.5A6.5 6.5 0 0 0 5.5 12c0 3.02 2.08 5.57 4.88 6.29v-1.72A4.87 4.87 0 0 1 7.12 12a4.88 4.88 0 0 1 9.76 0c0 2.03-1.24 3.78-3.01 4.53v1.72c2.8-.72 4.88-3.27 4.88-6.25A6.5 6.5 0 0 0 12 5.5Zm-.81 2.44h1.62v4.88h-1.62V7.94Z"
          fill="#81B5A1"
        />
      </svg>
    );
  }

  // 3. Fallback for any future provider added to backend without an icon
  const fallbackLetter = resolvedId ? resolvedId.slice(0, 2).toUpperCase() : "IT";

  return (
    <div
      className={`provider-avatar-fallback ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: "6px",
        background: "#F1F5F9",
        color: "#334155",
        fontWeight: 700,
        fontSize: Math.max(10, Math.floor(size * 0.45)),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #CBD5E1",
        ...style,
      }}
      title={provider?.name || resolvedId}
    >
      {fallbackLetter}
    </div>
  );
}
